export default {"src":"/_next/static/media/polkadot.bd50efd6.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};